import { Button as MuiButton } from "@material-ui/core";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
type Props = {
  children: any;
  disabled?: boolean;
  style: "submit" | "save" | "approve" | "reject" | "decline";
  type: "button" | "reset" | "submit";
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  className?: string;
};

const useStyles = makeThemedStyles("FormButton", (theme) => ({
  submitButton: {
    backgroundColor: "rgb(126, 135, 145, 0.5)",
    borderRadius: "26px",
    color: "#fff",
    width: "195px",
    height: "40px",
    "& .MuiButton-label": {
      fontSize: "14px",
    },
    "&.MuiButton-root:hover": {
      backgroundColor: "rgb(6, 156, 240)",
    },
  },
  saveButton: {
    background: "rgb(126, 135, 145, 0.5)",
    "&:hover": {
      backgroundColor: "rgb(6, 156, 240) !important",
    },
  },
  approveButton: {
    background: "rgb(126, 135, 145, 0.5)",
    "&:hover": {
      backgroundColor: "rgb(6, 156, 240) !important",
    },
  },
  rejectButton: {
    background: "rgb(126, 135, 145, 0.5)",
    "&:hover": {
      backgroundColor: "rgb(6, 156, 240) !important",
    },
  },
  declineButton: {
    background: "rgb(226, 35, 45)",
    "&:hover": {
      backgroundColor: "rgb(126, 135, 145, 0.7)",
    },
  },
}));

const FormButton = (props: Props) => {
  const classes = useStyles();
  const pickStyle =
    props.style === "approve"
      ? classes.approveButton
      : props.style === "reject"
      ? classes.rejectButton
      : props.style === "decline"
      ? classes.declineButton
      : props.style === "save"
      ? classes.saveButton
      : "";
  return (
    <MuiButton
      type={props.type}
      disabled={props.disabled === true}
      className={`${classes.submitButton} ${props.className} ${pickStyle}`}
      onClick={props.onClick}
    >
      {props.children}
    </MuiButton>
  );
};

export default FormButton;
